import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center items-center justify-center px-5 pt-12 pb-10 sm:pt-24 sm:pb-16 overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 30%, #1a1200 0%, #0a0a0a 60%)'
  }} data-id="element-148">
      {/* Ambient glow */}
      <div className="absolute top-[20%] left-1/2 -translate-x-1/2 w-[700px] h-[400px] rounded-full pointer-events-none opacity-60" style={{
      background: 'radial-gradient(ellipse, rgba(200,150,46,0.07) 0%, transparent 70%)'
    }} data-id="element-149" />

      {/* Brand */}
      <p className="relative text-[#C8962E]/70 text-xs sm:text-sm font-bold tracking-[0.3em] uppercase mb-6 sm:mb-8" data-id="element-150">
        💃 PROFEPACK™
      </p>

      {/* Headline */}
      <h1 className="relative font-black text-white max-w-3xl text-[2rem] sm:text-5xl md:text-[4.5rem] leading-[1.05] mb-5 sm:mb-7" data-id="element-151">
        Todo tu año de Tango
        <br data-id="element-152" />
        <span className="text-[#C8962E]" data-id="element-153">resuelto.</span>
      </h1>

      {/* Tagline — single punchy line */}
      <p className="text-sm sm:text-lg max-w-lg leading-relaxed mb-6 sm:mb-8 text-[#E7E7E7]" data-id="element-154">
        Clases · técnica · musicalidad · retención · corrección · negocio.
        <br className="hidden sm:inline" data-id="element-155" />
        <span className="text-white font-semibold" data-id="element-156">
          Listo para usar desde hoy.
        </span>
      </p>

      {/* Product image */}
      <div className="relative w-full max-w-[280px] sm:max-w-[380px] md:max-w-[450px] mx-auto mb-6 sm:mb-8" data-id="element-157">
        <div className="absolute inset-[-12px] rounded-3xl pointer-events-none" style={{
        background: 'radial-gradient(circle, rgba(200,150,46,0.06) 0%, transparent 60%)'
      }} data-id="element-158" />
        <img src="https://cdn.magicpatterns.com/uploads/rnVLba8etHgKJq6hH34vfj/PROYECTOS_Anuales_(1080_x_900_px)_(9).png" alt="PROFEPACK MegaPack Tango Listo — Combo Completo" className="relative w-full h-auto object-contain" width={1080} height={900} style={{
        aspectRatio: '1080/900'
      }} fetchPriority="high" data-id="element-159" />
      </div>

      {/* Feature bar */}
      <div className="flex sm:gap-5 sm:mb-9 text-gray-500 text-[11px] sm:text-xs font-medium tracking-wide uppercase mb-[20px] gap-[6px] flex-row items-center justify-center" data-id="element-160">
        <span className="text-[#FFFFFF]" data-id="element-161">📄 PDF</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-162" />
        <span className="text-[#FFFFFF]" data-id="element-163">⚡ Inmediato</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-164" />
        <span className="text-[#FFFFFF]" data-id="element-165">🇦🇷 Argentina</span>
        <span className="w-px h-3 bg-gray-700" data-id="element-166" />
        <span className="text-[#FFFFFF]" data-id="element-167">💃 Todos los niveles</span>
      </div>

      {/* Price anchor */}
      

      {/* CTA */}
      <a href="#pricing" className="btn-green-pulse green-shimmer relative text-black font-black text-base sm:text-xl px-10 sm:px-14 py-4 sm:py-5 rounded-2xl inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-md shadow-[0_0_40px_rgba(200,150,46,0.2)] hover:shadow-[0_0_60px_rgba(200,150,46,0.4)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-200" data-id="element-168">
        QUIERO MI PROFEPACK AHORA →
      </a>

      {/* Social proof micro-line */}
      <p className="text-gray-400 text-[10px] sm:text-xs mb-3 sm:mb-4 font-medium" data-id="element-169">
        ⚡ <span className="text-white" data-id="element-170">+500 profes</span> ya lo tienen
      </p>

      {/* Trust */}
      <p className="text-gray-500 text-[10px] sm:text-xs tracking-wide" data-id="element-171">
        🛡️ Garantía 7 días &nbsp;·&nbsp; 🔒 Pago seguro &nbsp;·&nbsp; 💳 Mercado
        Pago · Tarjeta · Transferencia
      </p>
    </section>;
}